'use strict';

const headerNavIconTokens = (theme) => ({
    headerNavIconRadius: '50%',
    headerNavIconPaddingX: theme.space.component.x.xs,
    headerNavIconPaddingY: theme.space.component.y.xs,
});

exports.headerNavIconTokens = headerNavIconTokens;
//# sourceMappingURL=headerNavIcon.js.map
